var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPipe = function SvgPipe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16v14h-3V16h3ZM8 29.43H4c-.55 0-1-.45-1-1V17.57c0-.55.45-1 1-1h4V15c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v1.57h18V15c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v1.57h4c.55 0 1 .45 1 1v10.86c0 .55-.45 1-1 1h-4V31c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1v-1.57H15V31c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-1.57Zm0-2v-8.86H5v8.86h3Zm7 0v-8.86h18v8.86H15Zm23 1V30h-3V16h3v12.43Zm2-1h3v-8.86h-3v8.86Z"
  })));
};

export default SvgPipe;